import { render, staticRenderFns } from "./Lgx184768857066438656.vue?vue&type=template&id=7a121d38&scoped=true&"
import script from "./Lgx184768857066438656.vue?vue&type=script&lang=js&"
export * from "./Lgx184768857066438656.vue?vue&type=script&lang=js&"
import style0 from "./Lgx184768857066438656.vue?vue&type=style&index=0&id=7a121d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a121d38",
  null
  
)

export default component.exports